import styled from 'styled-components';
import { GradientBar } from './GradientBar';
import { GradientContainer } from './GradientContainer';
import { heightRem } from '../constants';
import { Marker } from './Marker';

export interface Props {
  min: number;
  max: number;
  value: number;
  allowanceRange: [number, number];
}

export const MovableGradientBar: React.FC<Props> = ({ min, max, value, allowanceRange }) => {
  const markerRem = ((value - min) * heightRem) / (max - min);
  const gradientStartRem = ((value * allowanceRange[0] - min) * heightRem) / (max - min);
  const gradientEndRem = ((value * allowanceRange[1] - min) * heightRem) / (max - min);

  return (
    <Container $markerRem={markerRem}>
      <InnerBarWrapper $bottomRem={gradientStartRem} $heightRem={gradientEndRem - gradientStartRem}>
        <GradientBar />
      </InnerBarWrapper>
      <Marker data-testid="movableGradientBarMarker" $markerRem={markerRem} />
    </Container>
  );
};

const Container = styled(GradientContainer)<{ $markerRem: number }>`
  background: ${(props): string => `linear-gradient(0deg,
    hsl(0, 100%, 40%) ${props.$markerRem}rem,
    hsl(120, 100%, 40%) ${props.$markerRem}rem
  )`};
`;

export const InnerBarWrapper = styled.div<{ $bottomRem: number; $heightRem: number }>`
  bottom: ${(props): number => props.$bottomRem}rem;
  height: ${(props): number => props.$heightRem}rem;
  pointer-events: auto;
  position: absolute;
  width: 1.4rem;
`;
